import { useEffect, useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";

const LINE1 = "You want to build something of your own.".split(" ");

const ROTATING = [
  "what.",
  "which idea is actually viable.",
  "what fits your life.",
  "what people will pay for.",
  "which idea is bullshit.",
  "what you should actually build.",
];

const EASE = [0.22, 1, 0.36, 1];

export function KineticHeadline() {
  const reduce = useReducedMotion();
  const [i, setI] = useState(0);
  useEffect(() => {
    if (reduce) return;
    const id = setInterval(() => setI((p) => (p + 1) % ROTATING.length), 2800);
    return () => clearInterval(id);
  }, [reduce]);

  return (
    <h1
      className="font-heading font-extrabold text-[2rem] leading-[1.12] sm:text-5xl sm:leading-[1.06] lg:text-[3.4rem] tracking-tighter text-donkey-warm headline-glow [perspective:800px] break-words"
      data-testid="hero-headline"
    >
      <span className="block">
        {LINE1.map((w, idx) => (
          <motion.span
            key={w + idx}
            className="inline-block mr-[0.26em] headline-shimmer"
            style={{ animationDelay: reduce ? undefined : `${idx * 0.1}s` }}
            initial={reduce ? false : { opacity: 0, y: 28, rotateX: -70, filter: "blur(6px)" }}
            animate={{ opacity: 1, y: 0, rotateX: 0, filter: "blur(0px)" }}
            transition={{ duration: 0.6, delay: 0.05 + idx * 0.07, ease: EASE }}
          >
            {w}
          </motion.span>
        ))}
      </span>
      <motion.span
        className="block mt-1"
        initial={reduce ? false : { opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.62 }}
      >
        <span className="headline-shimmer" style={{ animationDelay: reduce ? undefined : "0.9s" }}>You just don't know </span>
        <span
          className="relative inline-block align-baseline"
          style={{ filter: "drop-shadow(0 0 18px rgba(249,115,22,0.45))" }}
        >
          <AnimatePresence mode="wait">
            <motion.span
              key={i}
              className="inline-block text-gradient-sweep"
              initial={reduce ? false : { opacity: 0, y: "0.45em", clipPath: "inset(0 0 100% 0)", filter: "blur(5px)" }}
              animate={{ opacity: 1, y: 0, clipPath: "inset(0 0 0% 0)", filter: "blur(0px)" }}
              exit={reduce ? undefined : { opacity: 0, y: "-0.4em", clipPath: "inset(100% 0 0 0)", filter: "blur(5px)" }}
              transition={{ duration: 0.55, ease: EASE }}
            >
              {ROTATING[i]}
            </motion.span>
          </AnimatePresence>
        </span>
      </motion.span>
    </h1>
  );
}

export default KineticHeadline;
